var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopHomeButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 24,
    fill: "#4073F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0859 35.3116C48.8227 34.4517 47.177 34.4517 45.9138 35.3116L36.3411 41.8283C35.2949 42.5405 34.6665 43.7396 34.6665 45.0236V57.4932C34.6665 59.614 36.3502 61.3334 38.4272 61.3334H43.8973C44.4637 61.3334 44.9229 60.8645 44.9229 60.286V53.3039C44.9229 52.3398 45.6882 51.5583 46.6323 51.5583H49.3674C50.3114 51.5583 51.0768 52.3398 51.0768 53.3039V60.286C51.0768 60.8645 51.536 61.3334 52.1024 61.3334H57.5725C59.6495 61.3334 61.3332 59.614 61.3332 57.4932V45.0236C61.3332 43.7396 60.7048 42.5405 59.6585 41.8283L50.0859 35.3116Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopHomeButton);
export default __webpack_public_path__ + "static/media/top_home_button.38176c0945821a98d5696c34a418557d.svg";
export { ForwardRef as ReactComponent };